import { FieldConfig } from '@peritos/api-client'

export const pacientesFieldConfig: FieldConfig<'pacientes'> = {
  nombre: {
    cols: {
      md: 4
    }
  },
  apellido_1: {
    cols: {
      md: 4
    }
  },
  apellido_2: {
    cols: {
      md: 4
    }
  },
  nif: {
    cols: {
      md: 4
    }
  },
  id_sexo: {
    cols: {
      md: 4
    }
  },
  fecha_nacimiento: {
    cols: {
      md: 4
    }
  },
  profesion: {
    cols: {
      md: 4
    }
  },
  id_lateralidad: {
    cols: {
      md: 4
    }
  },
  id_estado_civil: {
    cols: {
      md: 4
    }
  },
  num_hijos: {
    cols: {
      md: 4
    }
  },
  id_actividad_deportiva: {
    cols: {
      md: 4
    }
  },
  id_federado: {
    cols: {
      md: 4
    }
  },
  observaciones: {
    type: 'textarea',
    cols: {
      md: 12
    }
  }
}
